// store/filterStore.ts
import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import type { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";

export type Facets = {
    [key: string]: {
        items: RefinementListItem[];
        refine: (value: string) => void;
    };
};

interface FilterStore {
    // UI State
    filtersDialogOpened: boolean;
    sizeModalOpen: boolean;
    mobileSortByOpen: boolean;

    // Filter Data
    facets: Facets;
    sortByOptions: {
        options: any[];
        refine: (refinement: string) => void;
        currentRefinement: string;
    };
    resultCount?: number;

    // Actions
    setFiltersDialogOpened: () => void;
    openFiltersDialog: () => void;
    closeFiltersDialog: () => void;
    setSizeModalOpen: (open: boolean) => void;
    setMobileSortByOpen: (open: boolean) => void;
    setFilterItems: (items: Facets) => void;
    setSortByOptions: (options: any) => void;
    setResultCount?: (count: number) => void;
}

export const useFilterStore = create<FilterStore>()(
    subscribeWithSelector((set) => ({
        // Initial state
        filtersDialogOpened: false,
        sizeModalOpen: false,
        mobileSortByOpen: false,
        facets: {},
        sortByOptions: {
            options: [],
            refine: null,
            currentRefinement: null,
        },
        resultCount: undefined,

        // Actions
        setFiltersDialogOpened: () =>
            set((state) => ({
                filtersDialogOpened: !state.filtersDialogOpened,
            })),
        openFiltersDialog: () => set({ filtersDialogOpened: true }),
        closeFiltersDialog: () => set({ filtersDialogOpened: false }),
        setSizeModalOpen: (open) => set({ sizeModalOpen: open }),
        setMobileSortByOpen: (open) => set({ mobileSortByOpen: open }),
        setFilterItems: (items) => set({ facets: items }),
        setSortByOptions: (options) => set({ sortByOptions: options }),
        setResultCount: (count) => set({ resultCount: count }),
    }))
);
